import request from "@/utils/request.js"

// 获取省市区信息
export const listAddresses = () => {
    return request.get(`/address/all`)
}